import dateFns from 'date-fns';
import startOfDay from 'date-fns/start_of_day';

export const periodOptions = [
  {
    label: 'Alles',
    option: null,
    slug: 'alles',
  },
  {
    label: 'Afgelopen 24 uur',
    option: startOfDay(dateFns.addDays(Date.now(), -1)).toISOString(),
    slug: 'afgelopen24uur',
  },
  {
    label: 'Afgelopen week',
    option: startOfDay(dateFns.addDays(Date.now(), -7)).toISOString(),
    slug: 'afgelopenweek',
  },
  {
    label: 'Afgelopen maand',
    option: startOfDay(dateFns.addDays(Date.now(), -30)).toISOString(),
    slug: 'afgelopenmaand',
  },
  {
    label: 'Afgelopen jaar',
    option: startOfDay(dateFns.addDays(Date.now(), -365)).toISOString(),
    slug: 'afgelopenjaar',
  },
];

export const typeOptions = [
  {
    label: 'Alles',
    option: null,
    slug: 'alles',
  },
  {
    label: 'Afleveringen',
    option: 'BROADCAST',
    slug: 'afleveringen',
  },
  {
    label: 'Fragmenten',
    option: 'SEGMENT',
    slug: 'fragmenten',
  },
  {
    label: "Extra's",
    option: 'CLIP',
    slug: 'extras',
  },
];

const findOption = (options) => (slug) =>
  options.find((option) => option.slug === slug);

export const getType = findOption(typeOptions);
export const getPeriod = findOption(periodOptions);
